import * as React from 'react';
import { EFloors } from '../../../../types/buildersProjects';
import { Select } from '../Select';

const FLOORS_OPTIONS = [
  { label: '1 этаж', value: EFloors.One },
  { label: '2 этажа', value: EFloors.Two },
  { label: '3 этажа и более', value: EFloors.ThreeAndMore },
];

interface IFloorsDropdown {
  floors: EFloors[];
  onChange: (selected: EFloors[]) => void;
  filterRef: React.RefObject<HTMLDivElement | null>;
  onClose(): void;
  tooltipOpened: boolean;
}

export const FloorsDropdown: React.FC<IFloorsDropdown> = ({ floors, onChange, filterRef, onClose, tooltipOpened }) => {
  return (
    <Select
      selected={floors}
      options={FLOORS_OPTIONS}
      onChange={onChange}
      tooltipOpened={tooltipOpened}
      hostElement={filterRef.current}
      onApply={onClose}
    />
  );
};
